/*
 * Public API Surface of assets
 */

export * from './translations/translation-chunks-config';
export * from './translations/translations';
